export const setAnnouncerText = (announcerText) => {
  const announcerEl = document.getElementById('route-announcer');
  if (announcerEl && announcerText) {
    announcerEl.textContent = '';
    requestAnimationFrame(() => {
      announcerEl.textContent = announcerText;
    });
  }
};
